import { useEffect } from "react";

const useBeforeUnloadWarning = (isActive) => {
  useEffect(() => {
    if (!isActive || window.electron) return;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isActive]);
};

export default useBeforeUnloadWarning;
